import Cookies from 'js-cookie';

export const getFunlidayCookie = (name, req) => {
  let value;
  if (req) {
    value = req.cookies[`fld-${name}`];
  } else {
    value = Cookies.get(`fld-${name}`);
  }

  if (value) {
    try {
      value = JSON.parse(value);
    } catch (e) {
      value = '';
    }
  }

  return value;
};

export const setFunlidayCookie = (name, value, res) => {
  const stringifyValue = JSON.stringify(value);

  const opts = {
    sameSite: 'none',
    secure: true
  };

  if (res) {
    res.cookie(`fld-${name}`, stringifyValue);
  } else {
    Cookies.set(`fld-${name}`, stringifyValue);
  }

  return stringifyValue;
};

export const dropFunlidayCookie = (name, res) => {
  if (res) {
    res.clearCookie(`fld-${name}`);
  } else {
    Cookies.set(`fld-${name}`, '', { expires: 0 });
  }
};

const FunlidayCookie = {
  get: getFunlidayCookie,
  set: setFunlidayCookie,
  drop: dropFunlidayCookie
};
export default FunlidayCookie;
